var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxAllSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BTN_-CHECK_BOX_ALLSELECTED_NORMAL",
    "data-name": "BTN -CHECK BOX ALLSELECTED NORMAL",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ALL",
    d: "M7.333,22A1.367,1.367,0,0,1,6,20.667V7.333A1.367,1.367,0,0,1,7.333,6H20.667A1.367,1.367,0,0,1,22,7.333V20.667A1.367,1.367,0,0,1,20.667,22Zm5.311-4.733a.742.742,0,0,0,.256-.044.477.477,0,0,0,.211-.156L18.6,11.556a.64.64,0,0,0,.2-.467.715.715,0,0,0-.2-.489.7.7,0,0,0-.478-.178.652.652,0,0,0-.478.2l-5,5-2.178-2.178a.644.644,0,0,0-.933,0,.665.665,0,0,0-.2.489.594.594,0,0,0,.2.467l2.644,2.667a.644.644,0,0,0,.233.156A.683.683,0,0,0,12.644,17.267Z",
    transform: "translate(-2 -2)",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxAllSelected);
export default __webpack_public_path__ + "static/media/CheckBoxAllSelected.0f701bed4b56f5878a8136e1fd45c56a.svg";
export { ForwardRef as ReactComponent };